import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BackgroundCategory from '../../../domain/entities/BackgroundCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBackgroundCategoriesSuccess: {
      const result = action.payload as PaginatedResult<BackgroundCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
